import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CLOSE = 'close'
export const SAVE = 'save'
export const CHART_TYPE = 'chart type'
export const COLORS = 'colors'
export const DATA_TYPE = 'data type'
export const NUMBER_OF_WORDS = 'number-of-words'
export const FONT = 'font'

export default {
  [PORTUGUESE]: {
    [CLOSE]: 'Fechar',
    [SAVE]: 'Salvar',
    [CHART_TYPE]: 'Tipo de Gráfico',
    [COLORS]: 'Cores',
    [DATA_TYPE]: 'Tipo de Dados',
    [NUMBER_OF_WORDS]: 'Número de palavras',
    [FONT]: 'Fonte',
  },

  [ENGLISH]: {
    [CLOSE]: 'Close',
    [SAVE]: 'Save',
    [CHART_TYPE]: 'Chart Type',
    [COLORS]: 'Colors',
    [DATA_TYPE]: 'Data Type',
    [NUMBER_OF_WORDS]: 'Number of words',
    [FONT]: 'Font',
  },

  [SPANISH]: {
    [CLOSE]: 'Cerrar',
    [SAVE]: 'Guardar',
    [CHART_TYPE]: 'Tipo de Gráfico',
    [COLORS]: 'Colores',
    [DATA_TYPE]: 'Tipo de Datos',
    [NUMBER_OF_WORDS]: 'Número de palabras',
    [FONT]: 'Fuente',
  },
}
